const ITEMS = [
  "Denham Quarry",
  "Long Scar",
  "Wilton Quarry",
  "Anglezarke",
  "Trowbarrow",
  "Borrowdale",
  "Langdale",
  "Wasdale",
  "Bowland",
];

export default function Marquee() {
  const seq = [...ITEMS, ...ITEMS];
  return (
    <div
      className="overflow-hidden border-y border-[#5C5654]/15 bg-white py-6"
      data-testid="venue-marquee"
    >
      <div className="flex marquee-track gap-12 whitespace-nowrap">
        {seq.map((s, i) => (
          <div
            key={i}
            className="flex items-center gap-12 text-[#5C5654]"
          >
            <span
              className="font-display text-2xl md:text-3xl font-light tracking-tight"
              style={{ fontFamily: "Outfit, sans-serif" }}
            >
              {s}
            </span>
            <span className="w-2 h-2 rounded-full bg-[#3FB6B2]" />
          </div>
        ))}
      </div>
    </div>
  );
}
